const init = function () {
    const table = document.querySelector('[data-interactive-table]');
    if (!table) {
        return;
    }

    // Create menu element
    const menu = document.createElement('div');
    menu.className = 'custom-context-menu';
    menu.innerHTML = `
        <div class="menu-item" data-action="post">
            <i class="bi bi-check-circle text-success"></i> Провести
        </div>
        <div class="menu-item" data-action="unpost">
            <i class="bi bi-exclamation-triangle text-warning"></i> Сделать НЕ проведенным
        </div>
        <div class="menu-divider"></div>
        <div class="menu-item" data-action="restore">
            <i class="bi bi-arrow-counterclockwise"></i> Восстановить
        </div>
        <div class="menu-item" data-action="mark_for_deletion">
            <i class="bi bi-x-circle text-danger"></i> Пометить на удаление
        </div>
        <div class="menu-divider"></div>
        <div class="menu-item" data-action="post_all">
            <i class="bi bi-check-all"></i> Провести все что на экране
        </div>
    `;
    document.body.appendChild(menu);

    let targetRow = null;

    // Handle right click
    table.addEventListener('contextmenu', (e) => {
        const row = e.target.closest('tr');
        if (!row || !row.dataset.id) return;

        e.preventDefault();
        targetRow = row;

        // Reset highlights
        table.querySelectorAll('tr').forEach(r => r.classList.remove('context-highlight'));
        row.classList.add('context-highlight');

        menu.style.display = 'block';
        menu.style.left = `${e.pageX}px`;
        menu.style.top = `${e.pageY}px`;
    });

    // Close menu on click elsewhere
    document.addEventListener('click', (e) => {
        if (!menu.contains(e.target)) {
            menu.style.display = 'none';
            if (targetRow) targetRow.classList.remove('context-highlight');
        }
    });

    // Handle menu actions
    menu.querySelectorAll('.menu-item').forEach(item => {
        item.addEventListener('click', () => {
            const action = item.dataset.action;
            const actionText = item.textContent.trim();
            const entity = targetRow.dataset.entity;
            const id = targetRow.dataset.id;

            if (action === 'post_all') {
                if (confirm(`Вы уверены, что хотите: ${actionText}?`)) {
                    batchUpdate(entity, action);
                }
            } else {
                if (confirm(`Вы уверены, что хотите: ${actionText} для записи #${id}?`)) {
                    updateStatus(entity, id, action);
                }
            }
        });
    });

    function updateStatus(entity, id, action) {
        fetch(`/admin/status/${entity}/${id}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
            },
            body: JSON.stringify({action})
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    location.reload();
                } else {
                    alert(data.message);
                }
            });
    }

    function batchUpdate(entity, action) {
        const ids = Array.from(table.querySelectorAll('tbody tr[data-id]')).map(tr => tr.dataset.id);

        fetch(`/admin/status-batch/${entity}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
            },
            body: JSON.stringify({action: 'post', ids}) // Action for all is usually 'post'
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    location.reload();
                } else {
                    alert(data.message);
                }
            });
    }
}
export default {init};
